<template>
  <div id="v-widget">
    <v-card>
      <v-toolbar color="primary" class="white--text" flat dense card v-if="enableHeader">
        <v-toolbar-title><h5>{{title}}</h5></v-toolbar-title>
        <v-spacer></v-spacer>
        <slot name="widget-header-action"></slot>
      </v-toolbar>
      <v-divider v-if="enableHeader"></v-divider>
      <v-card-text :class="contentBg">
        <slot name="widget-content"></slot>
      </v-card-text>
      <slot name="widget-actions"></slot>

    </v-card>
  </div>
</template>

<script>
export default {
  name: 'v-widget',
  props: {
    title: {
      type: String
    },
    enableHeader: {
      type: Boolean,
      default: true
    },
    contentBg: {
      type: String,
      default: 'white'
    }
  },

  data () {
    return {

    }
  },
  computed: {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/widgets/VWidget.vue